import { NoomEventProto } from "@noom/noom-contracts/noom_contracts/events/noom_event";
import { Api } from "@noom/noomscape";

import axios from "axios";

Api.register(
  "eventProxy.putEvents",
  async ({
    events,
    accessToken,
  }: {
    events: NoomEventProto[];
    accessToken: string;
  }) =>
    axios({
      url: "/v1/events",
      urlWithPathParams: "/v1/events",
      baseURL: window.ENV.EDA_SERVER_URL,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      data: { events },
    }),
);
